import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import { ProductTemplateNewSection } from "ProductTemplate/ProductTemplateNewSection";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { useLoaderData } from "react-router";

const ProductTemplateNewApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ProductTemplateDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <ProductTemplateNewSection
            productGroups={viewModel.productGroups}
            vatRates={viewModel.vatRates}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <GeneralOptionsPanel
            links={[{
              text: RESX.Buttons.ListView,
              href: routes.productTemplate_List().absolute,
              visible: true
            }]}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>;
};

export default ProductTemplateNewApp;